import { cdn } from "constants/common";
import React from "react";
import Api from "services/api";

/**
 * Download link for the global appointment instructions document.
 *
 * The document is a single system-wide file managed under Tools > Appt
 * Instructions, so this renders nothing until an admin has uploaded one.
 *
 * Lives in the action-button row on each appointment view, right-aligned
 * opposite the buttons, and styled as a white pill so it reads as an action
 * alongside them rather than as a bare anchor.
 */
const AppointmentInstructionsLink = ({ className = "", style = {} }) => {
  const [document, setDocument] = React.useState(null);
  const [hover, setHover] = React.useState(false);

  React.useEffect(() => {
    let active = true;

    Api.getAppointmentInstructions().then((response) => {
      if (!active) return;
      if (response?.status === 200) {
        setDocument(response?.data?.data?.document || null);
      }
    });

    return () => {
      active = false;
    };
  }, []);

  if (!document?.path) return null;

  return (
    <a
      className={className}
      href={cdn + document.path}
      target="_blank"
      rel="noreferrer"
      title={`Open ${document.file_name}`}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 8,
        alignSelf: "center",
        flex: "0 0 auto",
        // Sits at the right-hand end of the action row, away from the buttons.
        marginLeft: "auto",
        whiteSpace: "nowrap",
        background: "#ffffff",
        color: "#6F8DFF",
        border: "1px solid #e0e7ef",
        borderRadius: 8,
        padding: "8px 14px",
        fontSize: 14,
        fontWeight: 600,
        lineHeight: 1.2,
        textDecoration: "none",
        boxShadow: hover
          ? "0 2px 10px rgba(23, 43, 77, 0.18)"
          : "0 1px 3px rgba(23, 43, 77, 0.08)",
        transition: "box-shadow 0.15s ease",
        ...style,
      }}
    >
      <i className="fa-solid fa-file-pdf" aria-hidden="true" />
      Appointment Instructions
    </a>
  );
};

export default AppointmentInstructionsLink;
